import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch, useAppSelector} from '../../redux';
import {latestNewsSelector} from '../../redux/selectors/news';
import {applyNewsFilter, getLatestNews} from '../../redux/actions/news';
import View from './view';
import {Forms} from '../../shared/models/forms';
import {formValueSelector, initialize} from 'redux-form';
import {FilterForm} from './components/filter/model';
import {defaults} from '../../shared/constants/defaults';
import {dateFormats, dateNewsFrom, dateNewsTo} from '../../shared/constants/date';
import format from 'date-fns/format';
const selector = formValueSelector(Forms.newsFilter);

const initialFormValues = {
  all: true,
  from: dateNewsFrom,
  to: dateNewsTo,
};

export const NewsScreen = () => {
  const latestNews = useSelector(latestNewsSelector());
  const dispatch = useAppDispatch();
  const selectionLoaded = useAppSelector((state) => state.news.selectionLoaded);
  const formData: FilterForm = useAppSelector((state) => selector(state, 'from', 'to', 'all'));
  const isFormInitialized =
    Boolean(formData && Object.keys(formData).length) &&
    formData.from instanceof Date &&
    formData.to instanceof Date &&
    typeof formData.all === 'boolean';

  // Initialize form if it's not initialized
  React.useEffect(() => {
    if (!isFormInitialized) {
      dispatch(initialize(Forms.newsFilter, initialFormValues));
    }
  }, [dispatch, formData]);

  // Latest news carousel
  useEffect(() => {
    if (latestNews === null) {
      dispatch(getLatestNews());
    }
  }, [dispatch, latestNews]);

  // All news with filter
  useEffect(() => {
    if (selectionLoaded || !isFormInitialized) return;

    const params = formData.all
      ? undefined
      : {
          from: format(formData.from, dateFormats.apiDate),
          to: format(formData.to, dateFormats.apiDate),
          perPage: defaults.newsPageSize,
        };

    dispatch(applyNewsFilter(params));
  }, [dispatch, formData, isFormInitialized, selectionLoaded]);

  return View({latestNews: latestNews});
};
